export default "__VITE_ASSET__0JgIyVAt__"